//============ ps.core.services.psreport.ReportParam =============
/* eslint-disable camelcase */
import {QueryParameter} from '@/base/QueryParameter';

export class ReportParam extends QueryParameter {
    constructor() {
        super();
    }



}